// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-message-setting-edit[data-v-45f736e6]{max-width:980px;margin-left:auto;margin-right:auto}#send-message-setting-edit .cancel-btn[data-v-45f736e6],#send-message-setting-edit .update-btn[data-v-45f736e6]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
